import { StyledCol, StyledRow } from 'src/layouts/styles';
import { CustomiseReport } from '~/features';
import { PageLayout } from '~/layouts';

const CustomiseReportRoute = () => {
    return (
        <PageLayout>
            <StyledRow>
                <StyledCol col={12}>
                    <CustomiseReport />
                </StyledCol>
            </StyledRow>
        </PageLayout>
    );
};
export default CustomiseReportRoute;
